import React from 'react';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Clock,
  ArrowRight,
  MessageSquare,
  Calendar,
  Zap
} from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const contactMethods = [
    {
      icon: <Mail className="contact-icon" />,
      title: "Email Us",
      description: "Get in touch via email",
      info: "hello@onskip.com",
      action: "Send Email"
    },
    {
      icon: <Phone className="contact-icon" />,
      title: "Call Us",
      description: "Speak with our team",
      info: "+92 (333) -154-2230",
      action: "Call Now"
    },
    {
      icon: <MessageSquare className="contact-icon" />,
      title: "Live Chat",
      description: "Chat with us online",
      info: "Available 9 AM - 6 PM EST",
      action: "Start Chat"
    }
  ];

  const services = [
    {
      icon: <Zap size={20} />,
      title: "Data & Workflow Automation",
      description: "Streamline your business processes"
    },
    {
      icon: <Calendar size={20} />,
      title: "Process Automation",
      description: "Optimize your business processes"
    },
    {
      icon: <MapPin size={20} />,
      title: "Web Development",
      description: "Custom websites and applications"
    }
  ];

  return (
    <section id="contact" className="contact section section-dark">
      <div className="container">
        <div className="contact-header">
          <h2>Let's Work Together</h2>
          <p>Ready to transform your business with smart automation and custom solutions?</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-intro">
              <h3>Get Started Today</h3>
              <p>
                Whether you need business process automation, data management solutions, or custom web development, 
                we're here to help. Let's discuss your project and explore how we can drive your business forward.
              </p>
            </div>

            <div className="contact-methods">
              {contactMethods.map((method, index) => (
                <div key={index} className="contact-method">
                  <div className="contact-method-icon">
                    {method.icon}
                  </div>
                  <div className="contact-method-content">
                    <h4>{method.title}</h4>
                    <p>{method.description}</p>
                    <span className="contact-info-text">{method.info}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="business-hours">
              <div className="hours-header">
                <Clock className="hours-icon" />
                <h4>Business Hours</h4>
              </div>
              <div className="hours-list">
                <div className="hours-item">
                  <span>Monday - Friday</span>
                  <span>9:00 AM - 6:00 PM EST</span>
                </div>
                <div className="hours-item">
                  <span>Saturday</span>
                  <span>10:00 AM - 4:00 PM EST</span>
                </div>
                <div className="hours-item">
                  <span>Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-action">
            <div className="action-card">
              <div className="action-header">
                <h3>Ready to Get Started?</h3>
                <p>Click below to visit our main site and get your free consultation</p>
              </div>

              <div className="services-preview">
                <h4>Our Services Include:</h4>
                <div className="services-list">
                  {services.map((service, index) => (
                    <div key={index} className="service-item">
                      <div className="service-icon-small">
                        {service.icon}
                      </div>
                      <div className="service-content">
                        <h5>{service.title}</h5>
                        <p>{service.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="action-buttons">
                <a 
                  href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                  className="btn btn-white btn-large primary-cta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Free Consultation <ArrowRight size={20} />
                </a>
                <a 
                  href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                  className="btn btn-secondary-white btn-large"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get Quote
                </a>
              </div>

              <div className="trust-indicators">
                <div className="trust-item">
                  <strong>100+</strong>
                  <span>Projects Completed</span>
                </div>
                <div className="trust-item">
                  <strong>50+</strong>
                  <span>Happy Clients</span>
                </div>
                <div className="trust-item">
                  <strong>24/7</strong>
                  <span>Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-bottom">
          <div className="contact-promise">
            <h3>Our Promise to You</h3>
            <div className="promise-grid">
              <div className="promise-item">
                <h4>Free Consultation</h4>
                <p>No-obligation discussion about your needs and goals</p>
              </div>
              <div className="promise-item">
                <h4>Custom Solutions</h4>
                <p>Tailored automation and development solutions for your business</p>
              </div>
              <div className="promise-item">
                <h4>Ongoing Support</h4>
                <p>Continued assistance to ensure your success</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
